export default "__VITE_ASSET__S87iZzzV__"